class calendarBlock {
    constructor() {

        let calendarBlockEl = document.getElementById('pollen-calendar-allergens-block');
        if (!calendarBlockEl) {
            return;
        }
        this.init();
    };

    async init() {
        let data = await this.fetchCalendarData();
        data.forEach( item => {
            console.log(item);
            let itemName = item.name.replaceAll(' ', '-');
            let itemNameTranslated = this.getTranslation(itemName);
            let itemType = item.type.toLowerCase();
            let sesionLowcolore, sesionMidcolore, sesionHighcolore = '';

            switch (itemType) {
            case 'tree':
                sesionLowcolore = '#E3EDC5';
                sesionMidcolore = '#42C8A0';
                sesionHighcolore = '#A9C23E';
                break;
            case 'grass':
                sesionLowcolore = '#D0EAC5';
                sesionMidcolore = '#B7B39E';
                sesionHighcolore = '#5E8954';
                break;
            case 'weed':
                sesionLowcolore = '#D1DCCF';
                sesionMidcolore = '#60A9A2';
                sesionHighcolore = '#7D998F';
                break;
            case 'hdm':
                sesionLowcolore = '#98C2E5';
                sesionMidcolore = '#6494bc';
                sesionHighcolore = '#3b8fd4';
                break;
            case 'spores':
                sesionLowcolore = '#C7DFA0';
                sesionMidcolore = '#96BC56';
                sesionHighcolore = '#445626';
            break;

            }

            var lowJson = '';
            if(item['low']){
                lowJson = JSON.stringify(item['low']);
            }
            var highJson = '';
            if(item['high']){
                highJson = JSON.stringify(item['high']);
            }

            document.getElementById('pollen-season__allergens-periods-wrapper').innerHTML += `
            <div class="allergen__type--0 d-flex flex-column flex-md-row pollen-season__allergen ${itemType}-allergen w-100 list-pollen-${itemName}">
                    <span class="align-items-center d-flex pe-2 pe-lg-3 pollen-season__allergen--name ${itemType}-allergen text-start"><span class="me-lg-2 me-1 d-inline-block rounded-pill"></span>${itemNameTranslated}</span>
                    <span class="flex-fill pollen-season__allergen--periods position-relative w-100">                        
                    ${this._creatHtml(`${itemType}-low-season`,`${lowJson}`, sesionLowcolore)}
                    ${this._creatHtml(`${itemType}-high-season`,`${highJson}`, sesionHighcolore)}
                    </span>
                </div>
            `
        });

        let checkboxes = document.querySelectorAll('.pollen-season__chart-legend input[type="checkbox"]');
        checkboxes.forEach( checkbox => {
            checkbox.addEventListener( 'change' , event => {                      
                event.preventDefault();
                document.querySelectorAll('.pollen-season__allergens-periods-wrapper.show .pollen-season__allergen').forEach( ListEl => { 
                    ListEl.classList.add('d-none'); 
                    ListEl.classList.remove('d-flex'); 
                });
                if (document.querySelectorAll('.pollen-season__chart-legend input[type="checkbox"]:checked').length > 0) {
                    document.querySelectorAll('.pollen-season__chart-legend input[type="checkbox"]:checked').forEach( checkedEl => {
                        document.querySelectorAll(`.pollen-season__allergens-periods-wrapper.show .pollen-season__allergen.${checkedEl.value}-allergen`).forEach( ListEl =>{ 
                            ListEl.classList.remove('d-none'); 
                            ListEl.classList.add('d-flex'); 
                        });

                    });
                    if(document.querySelectorAll('.pollen-season__chart-legend input[type="checkbox"]:checked').length < 4){
                        document.querySelectorAll('.pollen-season__allergens-periods-wrapper.show').forEach( ListEl => { 
                        ListEl.classList.add('checked-allergen'); 
                        });
                    }
                    else{
                        document.querySelectorAll('.pollen-season__allergens-periods-wrapper.show').forEach( ListEl => { 
                        ListEl.classList.remove('checked-allergen'); 
                        });
                    }
                }
                else {
                    document.querySelectorAll('.pollen-season__allergens-periods-wrapper.show .pollen-season__allergen').forEach( ListEl => { 
                        ListEl.classList.remove('d-none'); 
                        ListEl.classList.add('d-flex'); 
                    });
                    document.querySelectorAll('.pollen-season__allergens-periods-wrapper.show').forEach( ListEl => { 
                        ListEl.classList.remove('checked-allergen'); 
                    });
                }                
            });
        });
    
    };

    
    _creatHtml(className,arr, color){
        let html=``;
        if(arr != ''){
            arr=JSON.parse(arr);
            arr.forEach(a_width => {
                let left = (((((a_width.start) - 1 ) / 48.0 ) * 100 )).toFixed(2);
                let width = (((a_width.end/48.0) * 100 ).toFixed(2)) - left;
                let tempHtml=`<span class="period low-season position-absolute ${className}" style="left:${left}%; width: ${width}%; background: ${color};"></span>`;
                html+=tempHtml
            });
        }
        return html;
    }

    async fetchCalendarData() {
        let data = [];
        await  fetch(`https://alk-app.klarify.me/api/pollen-calendar/allergens`, {
            method: 'GET',
            headers: {
                'Authorization': `Bearer ${window.klarifyAppToken}`,
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            }
        }).then(response => response.json())
        .then(async (response) => {
            data.push(response.data.data);
        });

        return await data[0];
        
    }

    getTranslation(text) {
        this.curLang = localStorage.selectedLanguage;
        try {
            switch (text) {
                case 'Hazel':
                    return  'Líska';
                    break;
                case 'Alder':
                    return 'Olše';
                    break;
                case 'Poplar':
                    return 'Topol';
                    break;
                case 'Yew':
                    return 'Tis';
                    break;
                case 'Juniper':
                    return 'Jalovec';
                    break;
                case 'Birch':
                    return 'Bříza';
                    break;
                case 'Ash':
                    return 'Jasan';
                    break;
                case 'Hornbeam':
                    return 'Habr';
                    break;
                case 'Willow':
                    return 'Vrba';
                    break;
                case 'Maple':
                    return 'Javor';
                    break;
                case 'Oak':
                    return 'Dub';
                    break;
                case 'Platanus':
                    return 'Platanus';
                    break;
                case 'Walnut':
                    return 'Vlašský Ořech';
                    break;                
                case 'SweetChestnut':
                    return 'Sladký Kaštan';
                    break;
                case 'Pine':
                    return 'Borovice';
                    break;
                case 'BlackElderberry':
                    return 'Černý Bez';
                    break;
                case 'Pajasan':
                    return 'Pajasan';
                    break;
                case 'Linden':
                    return 'Lípa';
                    break;
                case 'Grass':
                    return 'Trávy';
                    break;
                case 'Plantain':
                    return 'Jitrocel';
                    break;
                case 'Sorrel':
                    return 'Šťovík';
                    break;
                case 'StingingNettle':
                    return 'Kopřiva Dvoudomá';
                    break;
                case 'Gooseberries':
                    return 'Angrešt';
                    break;
                case 'Wormwood':
                    return 'Pelyněk';
                    break;
                case 'Hops':
                    return 'Chmel';
                    break;
                case 'Ambrosia':
                    return 'Ambrózie';
                    break;
                case 'Alternaria':
                    return 'Plísně Alternaria';
                    break;
                case 'Cladosporium':
                    return 'Plísně Cladosporium';
                    break;
                case 'Aspergillus':
                    return 'Kropidlák';
                    break;
                case 'Penicillium':
                    return 'Plísně Penicillium';
                    break;
                case 'HDM':
                    return 'Roztoči';
                    break;
            }

        } catch (e) {
            console.error(e);
        }
    }

}


typeof calendarBlock !== 'undefined' && new calendarBlock();
